(function () {
  new Vue({
    el: '#cart',
    data: {
      messageText: '',
      messageAuthor: '',
      isOpenGiftBox: false,
      giftsId: [
        window.shop.miniCart.echantillons,
        window.shop.miniCart.totebag,
        window.shop.miniCart.giftboxGr,
        window.shop.miniCart.giftbox,
      ]
    },

    methods: {

      updateNote: function (event) {
        $.post('/cart/update.js', { note: $(event.currentTarget).val() }, null, 'json');
      },

      isGiftItem: function (item) {
        return this.giftsId.indexOf(item) > -1;
      },

      isGiftBox: function (item) {
        return item === window.shop.miniCart.giftbox;
      },

      openCartAddOns: function () {
        var cartGiftModal = $('.cart-gift-second');
        cartGiftModal.removeClass('cart-gift-hidden');

        if (!$('#checkBoxThree').is(':checked')) {
          this.disableTextFields();
        }
      },

      sliderManager: function () {
        let $slider = $('.cart-gift-content .choice-section__gift-boxes');
        if ($slider && !$slider.hasClass('slick-initialized')) {
          let giftSlider = $slider.slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 11 18"><path d="M1 1L9.15 9.15L1 17.3" stroke="#343434" stroke-width="2"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 11 18"><path d="M1 1L9.15 9.15L1 17.3" stroke="#343434" stroke-width="2"/></svg></button>',
          });
          giftSlider.get(0).slick.setPosition();
        }
      },

      unslickManager: function () {
        let $slider = $('.cart-gift-content .choice-section__gift-boxes');
        if ($slider && $slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      },


      toogleCartAddOns: function () {
        /*var cartGiftModal = $('.cart-gift-second');
        cartGiftModal.removeClass('cart-gift-hidden');

        if (!$('#checkBoxThree').is(':checked')) {
          this.disableTextFields();
        }*/

        var $giftContent = $('.cart-gift-content');
        $giftContent.slideToggle();
        this.isOpenGiftBox = !this.isOpenGiftBox;
        if (window.matchMedia('screen and (min-width:1200px)').matches) {
          this.unslickManager();
          this.sliderManager();
        }
        let that = this;
        $(window).on('resize', function () {
          if (window.matchMedia('screen and (min-width:1200px)').matches) {
            that.sliderManager();
          } else {
            that.unslickManager();
          }
        })

        /*if ($giftContent.find(':checkbox').is(':checked')) {
          this.enableTextFields();
        } else {
          //this.disableTextFields();
        }*/
      },

      closeCartAddOns: function () {
        var cartGiftModal = $('.cart-gift-second')
        cartGiftModal.addClass('cart-gift-hidden')
      },

      checkingBoxes: function (event) {
        var actualCheckBox = $(event.currentTarget).find(':checkbox');
        var checkBoxId = actualCheckBox.attr('id');

        if (actualCheckBox.is(':checked')) {
          actualCheckBox.prop('checked', false);
          if (checkBoxId === 'checkBoxThree') {
            this.disableTextFields();
          }
        } else {
          actualCheckBox.prop('checked', true);
          if (checkBoxId === 'checkBoxThree') {
            this.enableTextFields();
          }
        }
        this.updateGiftAddons();
      },

      checkingGiftBoxes: function (event, variantId, checkBoxId) {
        event.preventDefault();
        let checkBox = document.querySelector(`#${checkBoxId}`)
        var payload = {};
        if (checkBox) {
          if (checkBox.classList.contains('checked')) {
            checkBox.classList.remove('checked');
            payload[variantId] = 0;
            this.enableTextFields();
          } else {
            checkBox.classList.add('checked');
            payload[variantId] = 1;
          }
          this.updateCartQty(payload);
        }
      },


      updateCartQty: function (payload) {
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: payload }),
          keepalive: true
        }).then(response => response.json())
          .then(function (result) {
            window.location.reload();
          })
      },

      disableTextFields: function () {
        $('#wrap-message').prop('disabled', true);
        $('#wrap-message').val('');
        $('#wrap-author').prop('disabled', true);
        $('#wrap-author').val('');
      },

      enableTextFields: function () {
        $('#wrap-message').prop('disabled', false);
        $('#wrap-author').prop('disabled', false);
      },

      emptyLocalStorage: function () {
        // if validation without reloading, empty localStorage data
        localStorage.removeItem('message')
        localStorage.removeItem('author')
        //localStorage.removeItem('finalSentence')
        localStorage.removeItem('checkBoxTwo')
        //localStorage.removeItem('checkBoxOne')
        localStorage.removeItem('checkBoxThree')
      },

      textAreaTyping: function () {
        var actualCheckBox = $('#checkBoxThree')
        var wrapMessage = $('#wrap-message').val();
        if (wrapMessage) {
          actualCheckBox.prop('checked', true);
        } else {
          actualCheckBox.prop('checked', false);
        }
      },

      updateMessage: function (e, t) {
        this.updateGiftAddons();
      },

      updateGiftAddons: function (event) {
        if (event) event.preventDefault();
        //var checkBoxOne = $('#checkBoxOne')
        var cartGiftModal = $('.cart-gift-second')
        var wrapMessage = $('#wrap-message').val() || '';
        var messageAuthor = $('#wrap-author').val() || '';
        var cartAmount = $('.cart-total__amount')[0].innerHTML.split(" ")[0]
        cartAmount = parseFloat(cartAmount)

        // rewrite all gift attributes depending on conditions
        var giftAttributes = {};

        giftAttributes['@@Message cadeau@@'] = wrapMessage;
        giftAttributes['@@Nom expéditeur@@'] = messageAuthor;

        $.post('/cart/update.js', { attributes: giftAttributes }, null, 'json')
          .done(function () {

            /*if (checkBoxOne.is(':checked')) {
              localStorage.setItem('checkBoxOne', 'true')
            } else {
              localStorage.setItem('checkBoxOne', 'false')
            }*/

            // store local data
            localStorage.setItem('message', wrapMessage || '');
            localStorage.setItem('author', messageAuthor || '');

          });
      },

      updateCart: function () {
        //var checkBoxOneStore = localStorage.getItem('checkBoxOne')
        var author = localStorage.getItem('author');
        var message = localStorage.getItem('message');

        var giftAttributes = {};

        if (author !== '' || message !== '') {
          giftAttributes['@@Message cadeau@@'] = localStorage.getItem('message');
          giftAttributes['@@Nom expéditeur@@'] = localStorage.getItem('author');
        } else {
          giftAttributes['@@Message cadeau@@'] = '';
          giftAttributes['@@Nom expéditeur@@'] = '';
        }

        //cartGiftCta.html(localStorage.getItem('finalSentence') || 'c\'est un cadeau ?')
        $.post('/cart/update.js', { attributes: giftAttributes }, null, 'json');

        this.messageText = localStorage.getItem('message') || '';
        this.messageAuthor = localStorage.getItem('author') || '';

      },

      gtmAddToCart: function (handle, variantId) {
        $(document).trigger('gtm.addToCart', [{ handle: handle, id: variantId, quantity: 1, template: 'Cart Page' }]);
      }

    },

    mounted: function () {
      this.updateCart()

      const hasOpen = document.querySelector('.cart-gift')?.dataset?.hasOpen === 'true';
      if (hasOpen) {
        this.toogleCartAddOns();
      }

      // reload page after removing unique gift boxes
      var items = $('.cart-item')
      var boxItemName = $('a[href*="?variant=13544189296702"]')[1] || $('a[href*="?variant=18026821058622"]')[1]
      if (items.length === 1 && boxItemName) {
        window.onload = function () {
          $.ajax({
            url: '/cart/update.js',
            method: 'post',
            dataType: 'json',
            data: { updates: { 13544189296702: 0, 18026821058622: 0 } }
          }).then(function () {
            // and reload page completely
            window.location.reload();
            return;
          });
        }
      }

      // scroll to cart top after update
      window.onload = function () {
        $('html, body').animate({
          scrollTop: 0
        }, 1000);
      }

      if (window.matchMedia('screen and (min-width:1200px)').matches) {
        this.sliderManager();
      }
      let that = this;
      $(window).on('resize', function () {
        if (window.matchMedia('screen and (min-width:1200px)').matches) {
          that.sliderManager();
        } else {
          that.unslickManager();
        }
      })
    },

    watch: {
      messageText: function (e) {
        let search = e.search(this.regex);
        if (search > -1) {
          this.messageText = e.replace(this.regex, "");
        }
      },
      messageAuthor: function (e) {
        let search = e.search(this.regex);
        if (search > -1) {
          this.messageAuthor = e.replace(this.regex, "");
        }
      }
    }

  });
}());